import React from 'react';
import { Empty, Upload, UploadProps } from 'antd';
import { useTranslation } from 'react-i18next';
import classes from './CustomDragger.module.scss';
import { useAppSelector } from 'store/hook';
import { PaperClipOutlined } from '@ant-design/icons';

type CustomDraggerProps = {
  uploadProps: UploadProps;
};

const CustomDragger = ({uploadProps}: CustomDraggerProps) => {
  const { displayChatDragger } = useAppSelector((state) => state.chat);
  const { t } = useTranslation();

  return (
    <>
      <Upload {...uploadProps} accept='image/*'>
        <PaperClipOutlined className={classes.attachmentIcon} />
      </Upload>
      <Upload.Dragger
        {...uploadProps}
        className={
          displayChatDragger
            ? classes.dropDownActive
            : classes.dropDownNone
        }
        openFileDialogOnClick={false}
      >
        <Empty
          rootClassName={classes.emptyElement}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={t('Chats.modals.dropText')}
        />
      </Upload.Dragger>
    </>
  );
}

export default CustomDragger;
